import script from "./InputText.vue?vue&type=script&setup=true&lang=ts"
export * from "./InputText.vue?vue&type=script&setup=true&lang=ts"

import "./InputText.vue?vue&type=style&index=0&id=8ce25750&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8ce25750"]])

export default __exports__